.Main {
}

.Main :last-child {
    border-bottom: none;
}

.Item {
    line-height: 1.7;
    padding: var(--small-space) 0;
    border-bottom: solid 2px currentColor;
    hyphens: auto;
}

.Item a {
    text-decoration: none;
    border-bottom: solid 2px currentColor;
}